import { render, staticRenderFns } from "./logged.vue?vue&type=template&id=2222d638&scoped=true&"
import script from "./logged.vue?vue&type=script&lang=js&"
export * from "./logged.vue?vue&type=script&lang=js&"
import style0 from "./logged.vue?vue&type=style&index=0&id=2222d638&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2222d638",
  null
  
)

component.options.__file = "logged.vue"
export default component.exports